module.exports = __webpack_public_path__ + "img/logo-doen-original.fc7da85.svg";